import { ISaleInvoiceSummary } from "types/response/saleReportResponse"

// Colores primarios
export const COLOR_PRIMARY = "#D40511"
export const COLOR_PRIMARY_DARK = "#b0040d"
export const COLOR_PRIMARY_SHADOW = "rgba(212,5,17,0.35)"

// Colores de superficie / fondos
export const COLOR_HEADER_BG = "#333"
export const COLOR_TOTAL_BG = "#1a1a1a"
export const COLOR_SURFACE_LIGHT = "#f8faff"
export const COLOR_SURFACE_ACCENT = "#e8f0fe"
export const COLOR_BORDER_LIGHT = "#e8eef8"

// Colores de texto
export const COLOR_TEXT_PRIMARY = "#1a1a1a"
export const COLOR_TEXT_SECONDARY = "#555"
export const COLOR_TEXT_MUTED = "#666"
export const COLOR_TEXT_HINT = "#7a2e00"
export const COLOR_TEXT_DISABLED = "#aaa"
export const COLOR_TEXT_PLACEHOLDER = "#bbb"
export const COLOR_TEXT_BORDER = "#ccc"
export const COLOR_TEXT_SUBTLE = "#777"

// Colores de estado
export const COLOR_SUCCESS_BG = "#e8f5e9"
export const COLOR_SUCCESS = "#2e7d32"
export const COLOR_WARNING = "#ffb300"

// Colores de chip / filtro
export const COLOR_CHIP_BG = "#e8f0fe"

// Colores misceláneos
export const COLOR_ICON_EMPTY = "#ddd"
export const COLOR_WHITE = "#fff"
export const COLOR_ACCENT_ORANGE = "#ff9100"

// Quincenas
export enum Quincena {
  Q1 = "Q1",
  Q2 = "Q2",
  ALL = "ALL",
}

export const QUINCENA_VALUE: Record<Quincena, number> = {
  [Quincena.Q1]: 1,
  [Quincena.Q2]: 2,
  [Quincena.ALL]: 0,
}

//Meses
export const MESES_LIST = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
]

//Filtros combinados 
export const FILTER_FIELDS = [
  { field: "noDoc", label: "NUM FACTURA" },
  { field: "rif", label: "RIF" },
  { field: "clientName", label: "CLIENTE" },
] as const

export type FilterField = (typeof FILTER_FIELDS)[number]["field"]

export const FILTER_FIELD_LABELS: Record<FilterField, string> = {
  noDoc: "Num Factura",
  rif: "RIF",
  clientName: "Cliente",
}

// Columnas fijas de encabezado (NUM FACTURA / RIF / CLIENTE)
export const HEADER_FIXED_COLUMNS = [
  { label: "NUM FACTURA", width: 120 },
  { label: "RIF", width: 120 },
  { label: "CLIENTE", width: 300 },
]

// Columnas de encabezado para Resumen Mayor (incluye BASE IMPONIBLE AR)
export const SUMMARY_REPORT_HEADER_COLUMNS = [
  { label: "NUM FACTURA", width: 120 },
  { label: "RIF", width: 120 },
  { label: "CLIENTE", width: 300 },
  { label: "BASE IMPONIBLE AR", width: 160 },
  { label: "IVA AR", width: 160 },
]

// Columnas del reporte de ventas
export const SALE_REPORT_COLUMNS: {
  id: keyof ISaleInvoiceSummary
  label: string
}[] = [
  { id: "refundRu", label: "Base 0 RU" },
  { id: "refundLedger", label: "Reembolso Mayor" },
  { id: "sale0Ru", label: "Venta 0 RU" },
  { id: "sale0Ledger", label: "Venta 0 Mayor" },
  { id: "igtfLedger", label: "IGTF Mayor" },
  { id: "baseIva16Ru", label: "Base IVA 16 RU" },
  { id: "baseIva16Ledger", label: "Base IVA 16 Mayor" },
  { id: "iva16Ru", label: "IVA 16 RU" },
  { id: "iva16Ledger", label: "IVA 16 Mayor" },
  { id: "subtotalInvoiceRu", label: "Subtotal Factura RU" },
  { id: "subtotalInvoiceLedger", label: "Subtotal Factura Mayor" },
  { id: "totalInvoiceRu", label: "Total Factura RU" },
  { id: "totalInvoiceLedger", label: "Total Factura Mayor" },
]

// Paginación
export const PAGE_SIZE = 50

// ─── Tipos de estado compartidos ─────────────────────────────────────────────
export interface FilterConfig {
  noDoc: string[]
  rif: string[]
  clientName: string[]
  activeField: FilterField
  inputValue: string
}

export interface AccountTotal {
  accountNumber: string
  amount: number
}

export const DEFAULT_FILTER_CONFIG: FilterConfig = {
  noDoc: [],
  rif: [],
  clientName: [],
  activeField: "noDoc",
  inputValue: "",
}

// Años disponibles en los filtros (desde 2025 hasta el año actual)
export const ANIO_BASE = 2025
export const ANIOS_LIST = Array.from(
  { length: new Date().getFullYear() - ANIO_BASE + 1 },
  (_, i) => String(ANIO_BASE + i),
)
